import { Environment } from '@abp/ng.core';

const baseUrl = 'https://zendra-cbd-staging.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://zendra-infra-auth-server-staging.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'CBD',
  responseType: 'code',
  scope:
    'offline_access openid profile email phone AuthServer IdentityService AdministrationService AuditLoggingService SaasService LanguageService Controlling General Planning WoodSecurity WoodSupply Orchestrator Geographic Operational Inventory',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  },
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'CBD',
  },
  localization: {
    defaultResourceName: 'CBD',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://zendra-infra-webgateway-staging.upmuruguay.net',
      rootNamespace: 'Upm.Zendra.CBD',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
    General: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.General',
    },
    Controlling: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.Controlling',
    },
    Planning: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.Planning',
    },
    WoodSupply: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.WoodSupply',
    },
    WoodSecurity: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.WoodSecurity',
    },
    Orchestrator: {
      url: 'https://zendra-cbd-webgateway-staging.upmuruguay.net/',
      rootNamespace: 'Upm.Zendra.CBD.Orchestrator',
    },
    AdministrationService: {
      url: 'https://zendra-infra-webgateway-staging.upmuruguay.net',
      rootNamespace: 'Upm.Zendra.AdministrationService',
    },
    IdentityService: {
      url: 'https://zendra-infra-webgateway-staging.upmuruguay.net',
      rootNamespace: 'Upm.Zendra.IdentityService',
    },
  },
  grafana: {
    isEnabled: false,
    appName: 'Zendra CBD Staging',
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/4f394d3154ca18e4400fc95e96e06f58',
  },
  newRelicFrontend: {
    isEnabled: false,
  }
} as Environment;
